/**
 * SVG Shape Data & Clip/Overlay Functions
 * Shared between Django backend frontend and Shopify frontend.
 * Uses ONE heart + ONE circle SVG for ALL sizes and orientations.
 * preserveAspectRatio="xMidYMid meet" keeps shapes undistorted.
 *
 * How it works:
 * - Frame overlay SVG uses preserveAspectRatio to stay undistorted
 * - Clip-path SVG also uses preserveAspectRatio via a full-size SVG
 *   with userSpaceOnUse, so the clip shape matches the overlay exactly
 * - Both scale identically regardless of container aspect ratio
 */

const SVG_SHAPES = {
	heart: {
		viewBox: '0 0 1133.86 1190.55',
		width: 1133.86,
		height: 1190.55,
		// Frame path: rectangle with heart cutout (fill = background color)
		framePath: 'M0,0v1190.55h1133.86V0H0z M566.94,1015.44c-4.22-2.29-8.42-4.6-12.61-6.91c-1.47-0.81-2.93-1.63-4.39-2.44 c-2.69-1.5-5.39-2.99-8.07-4.5c-1.79-1-3.56-2.01-5.34-3.01c-2.34-1.32-4.68-2.65-7.01-3.97c-1.92-1.1-3.84-2.2-5.76-3.3 c-2.14-1.23-4.27-2.46-6.4-3.7c-2.04-1.18-4.09-2.37-6.12-3.56c-1.93-1.13-3.85-2.26-5.77-3.39c-2.19-1.29-4.37-2.57-6.55-3.87 c-1.55-0.92-3.09-1.85-4.63-2.77c-9.5-5.68-18.9-11.41-28.18-17.2c-0.43-0.27-0.87-0.54-1.3-0.81c-3.08-1.92-6.14-3.85-9.19-5.78 c-0.7-0.44-1.39-0.88-2.09-1.32c-3.06-1.94-6.11-3.9-9.15-5.85c-0.59-0.38-1.18-0.76-1.78-1.14c-3.2-2.06-6.38-4.13-9.55-6.21 c-0.26-0.17-0.51-0.33-0.76-0.5C214.09,792.1,63.93,619.67,63.93,426.86c0-240.2,294.36-363.52,503.02-117.17 c138.57-163.6,314.89-164.14,417.73-75.71c0.18,0.15,0.35,0.3,0.53,0.45c1.86,1.61,3.7,3.25,5.51,4.91 c0.15,0.14,0.29,0.28,0.44,0.41c7.37,6.82,14.32,14.11,20.81,21.86c0.35,0.41,0.7,0.82,1.04,1.23c1.35,1.63,2.67,3.29,3.98,4.96 c0.48,0.61,0.95,1.22,1.42,1.84c1.25,1.63,2.48,3.26,3.69,4.93c0.46,0.63,0.91,1.28,1.36,1.91c3.86,5.41,7.5,11,10.93,16.77 c0.49,0.82,0.99,1.63,1.47,2.46c0.88,1.52,1.73,3.06,2.58,4.61c0.61,1.11,1.22,2.21,1.81,3.33c0.78,1.47,1.55,2.96,2.3,4.46 c0.63,1.24,1.24,2.49,1.84,3.74c0.7,1.44,1.39,2.88,2.06,4.35c0.65,1.42,1.27,2.85,1.9,4.29c0.59,1.34,1.19,2.68,1.75,4.04 c1.1,2.65,2.16,5.34,3.18,8.05c0.44,1.17,0.84,2.36,1.26,3.53c0.63,1.77,1.26,3.54,1.86,5.32c0.43,1.29,0.84,2.6,1.25,3.9 c0.55,1.73,1.08,3.47,1.59,5.22c0.38,1.3,0.75,2.61,1.11,3.92c0.51,1.86,0.99,3.73,1.46,5.6c0.3,1.22,0.62,2.43,0.91,3.65 c0.56,2.36,1.07,4.74,1.56,7.14c0.16,0.76,0.33,1.51,0.48,2.27c0.62,3.13,1.17,6.29,1.68,9.48c0.16,1,0.29,2.02,0.44,3.02 c0.34,2.26,0.65,4.53,0.93,6.82c0.15,1.22,0.28,2.44,0.41,3.67c0.23,2.15,0.44,4.3,0.63,6.47c0.11,1.24,0.21,2.48,0.3,3.73 c0.17,2.31,0.29,4.63,0.4,6.96c0.05,1.09,0.12,2.17,0.16,3.26c0.12,3.42,0.2,6.85,0.2,10.32 C1069.93,657.23,866.93,848.04,566.94,1015.44z',
		// Border path: heart outline (stroke only)
		borderPath: 'M1069.73,416.54c-0.04-1.09-0.1-2.17-0.16-3.26c-0.11-2.33-0.24-4.66-0.4-6.96c-0.09-1.25-0.19-2.49-0.3-3.73 c-0.18-2.17-0.4-4.33-0.63-6.47c-0.13-1.22-0.26-2.45-0.41-3.67c-0.28-2.29-0.6-4.56-0.93-6.82c-0.15-1.01-0.28-2.02-0.44-3.02 c-0.51-3.19-1.07-6.35-1.68-9.48c-0.15-0.76-0.33-1.51-0.48-2.27c-0.49-2.39-1.01-4.78-1.56-7.14c-0.29-1.22-0.6-2.44-0.91-3.65 c-0.47-1.88-0.95-3.75-1.46-5.6c-0.36-1.31-0.73-2.62-1.11-3.92c-0.51-1.75-1.04-3.49-1.59-5.22c-0.41-1.3-0.82-2.61-1.25-3.9 c-0.6-1.79-1.23-3.56-1.86-5.32c-0.42-1.18-0.82-2.37-1.26-3.53c-1.02-2.71-2.08-5.39-3.18-8.05c-0.56-1.36-1.17-2.69-1.75-4.04 c-0.63-1.43-1.25-2.87-1.9-4.29c-0.67-1.46-1.37-2.9-2.06-4.35c-0.61-1.25-1.22-2.5-1.84-3.74c-0.75-1.5-1.52-2.98-2.3-4.46 c-0.59-1.12-1.2-2.22-1.81-3.33c-0.85-1.54-1.7-3.09-2.58-4.61c-0.48-0.83-0.98-1.64-1.47-2.46c-3.43-5.77-7.08-11.36-10.93-16.77 c-0.46-0.64-0.9-1.28-1.36-1.91c-1.21-1.66-2.45-3.3-3.69-4.93c-0.47-0.61-0.95-1.23-1.42-1.84c-1.31-1.67-2.63-3.33-3.98-4.96 c-0.34-0.41-0.69-0.82-1.04-1.23c-6.49-7.74-13.44-15.04-20.81-21.86c-0.15-0.14-0.29-0.28-0.44-0.41c-1.81-1.67-3.65-3.3-5.51-4.91 c-0.18-0.15-0.35-0.3-0.53-0.45c-102.84-88.43-279.16-87.89-417.73,75.71C358.28,63.34,63.93,186.66,63.93,426.86 c0,192.81,150.17,365.24,368.36,508.34c0.25,0.17,0.51,0.33,0.76,0.5c3.17,2.08,6.36,4.15,9.55,6.21c0.59,0.38,1.18,0.76,1.78,1.14 c3.04,1.96,6.09,3.91,9.15,5.85c0.69,0.44,1.39,0.88,2.09,1.32c3.05,1.93,6.11,3.86,9.19,5.78c0.43,0.27,0.87,0.54,1.3,0.81 c9.29,5.78,18.68,11.52,28.18,17.2c1.54,0.92,3.08,1.85,4.63,2.77c2.18,1.29,4.36,2.58,6.55,3.87c1.92,1.13,3.84,2.26,5.77,3.39 c2.03,1.19,4.08,2.37,6.12,3.56c2.13,1.23,4.26,2.47,6.4,3.7c1.92,1.1,3.83,2.2,5.76,3.3c2.33,1.33,4.67,2.65,7.01,3.97 c1.78,1.01,3.56,2.01,5.34,3.01c2.68,1.5,5.37,3,8.07,4.5c1.46,0.81,2.92,1.63,4.39,2.44c4.19,2.31,8.39,4.62,12.61,6.91 c299.99-167.4,502.99-358.21,502.99-588.58C1069.93,423.4,1069.86,419.96,1069.73,416.54z',
		borderStroke: '#000000'
	},
	circle: {
		viewBox: '0 0 1133.86 1190.55',
		width: 1133.86,
		height: 1190.55,
		// Frame path: rectangle with ellipse cutout
		framePath: 'M0,0v1190.55h1133.86V0H0z M566.93,1105.89c-277.8,0-503-228.61-503-510.62s225.2-510.62,503-510.62 s503,228.61,503,510.62S844.73,1105.89,566.93,1105.89z',
		// Ellipse data for clip-path and border
		ellipseCx: 566.93,
		ellipseCy: 595.28,
		ellipseRx: 503,
		ellipseRy: 510.62,
		borderStroke: '#000000'
	}
};

/**
 * Apply SVG clip-path and frame overlay to the map container.
 * Both use preserveAspectRatio="xMidYMid meet" so the shape is NEVER stretched.
 * @param {string} shape - 'circle', 'full-heart', or falsy for no shape
 * @param {HTMLElement} [mapEl] - The #map element (defaults to document.getElementById('map'))
 */
function applyShapeClip(shape, mapEl) {
	const mapContainer = mapEl || document.getElementById('map');
	if (!mapContainer) return;

	// Clean up previous clip/overlay
	removeShapeClip(mapContainer);

	// If no shape or square/default, just clear and return
	if (!shape || shape === 'square' || shape === 'default') {
		mapContainer.style.clipPath = 'none';
		return;
	}

	// Map layout name to shape data key
	const shapeKey = shape === 'full-heart' ? 'heart' : shape;
	const data = SVG_SHAPES[shapeKey];
	if (!data) return;

	const innEl = mapContainer.closest('.inn') || mapContainer.parentElement;
	const containerWidth = mapContainer.offsetWidth;
	const containerHeight = mapContainer.offsetHeight;

	// 1. Create SVG for <clipPath> with userSpaceOnUse
	// This SVG is sized to the map container and uses the same viewBox + preserveAspectRatio
	// as the frame overlay, so the clip shape stays undistorted and perfectly aligned.
	const clipSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	clipSvg.setAttribute('id', 'shape-clip-svg');
	clipSvg.setAttribute('width', containerWidth);
	clipSvg.setAttribute('height', containerHeight);
	clipSvg.setAttribute('viewBox', data.viewBox);
	clipSvg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
	clipSvg.style.position = 'absolute';
	clipSvg.style.top = '0';
	clipSvg.style.left = '0';
	clipSvg.style.pointerEvents = 'none';
	clipSvg.style.width = '0';
	clipSvg.style.height = '0';
	clipSvg.style.overflow = 'visible';

	const clipPathEl = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
	clipPathEl.setAttribute('id', 'active-shape-clip');
	clipPathEl.setAttribute('clipPathUnits', 'userSpaceOnUse');

	if (shapeKey === 'circle') {
		const ellipse = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse');
		// Compute pixel coordinates using preserveAspectRatio="xMidYMid meet" math
		const fit = computeMeetTransform(data.width, data.height, containerWidth, containerHeight);
		ellipse.setAttribute('cx', fit.tx + data.ellipseCx * fit.scale);
		ellipse.setAttribute('cy', fit.ty + data.ellipseCy * fit.scale);
		ellipse.setAttribute('rx', data.ellipseRx * fit.scale);
		ellipse.setAttribute('ry', data.ellipseRy * fit.scale);
		clipPathEl.appendChild(ellipse);
	} else {
		// Heart: transform the path to pixel coordinates
		const fit = computeMeetTransform(data.width, data.height, containerWidth, containerHeight);
		const clipPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
		clipPath.setAttribute('d', data.borderPath);
		clipPath.setAttribute('transform', 'translate(' + fit.tx + ',' + fit.ty + ') scale(' + fit.scale + ')');
		clipPathEl.appendChild(clipPath);
	}

	clipSvg.appendChild(clipPathEl);
	innEl.appendChild(clipSvg);

	// Apply clip-path to map container
	mapContainer.style.clipPath = 'url(#active-shape-clip)';

	// 2. Create frame overlay SVG (covers outside area + draws border)
	const frameSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	frameSvg.setAttribute('id', 'shape-frame-svg');
	frameSvg.setAttribute('viewBox', data.viewBox);
	frameSvg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
	frameSvg.style.position = 'absolute';
	frameSvg.style.top = '0';
	frameSvg.style.left = '0';
	frameSvg.style.width = '100%';
	frameSvg.style.height = containerHeight + 'px';
	frameSvg.style.pointerEvents = 'none';
	frameSvg.style.zIndex = '2';

	// Frame path (rect with shape cutout) — fill with current background color
	const bgColor = getCurrentBackgroundColor();
	const framePath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
	framePath.setAttribute('id', 'shape-frame-path');
	framePath.setAttribute('d', data.framePath);
	framePath.setAttribute('fill', bgColor);
	framePath.setAttribute('stroke', 'none');
	frameSvg.appendChild(framePath);

	// Border path (shape outline)
	if (shapeKey === 'circle') {
		const borderEllipse = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse');
		borderEllipse.setAttribute('cx', data.ellipseCx);
		borderEllipse.setAttribute('cy', data.ellipseCy);
		borderEllipse.setAttribute('rx', data.ellipseRx);
		borderEllipse.setAttribute('ry', data.ellipseRy);
		borderEllipse.setAttribute('fill', 'none');
		borderEllipse.setAttribute('stroke', data.borderStroke);
		borderEllipse.setAttribute('stroke-miterlimit', '10');
		frameSvg.appendChild(borderEllipse);
	} else {
		const borderPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
		borderPath.setAttribute('d', data.borderPath);
		borderPath.setAttribute('fill', 'none');
		borderPath.setAttribute('stroke', data.borderStroke);
		borderPath.setAttribute('stroke-miterlimit', '10');
		frameSvg.appendChild(borderPath);
	}

	innEl.appendChild(frameSvg);
}

/**
 * Compute the transform for preserveAspectRatio="xMidYMid meet".
 * Returns { scale, tx, ty } to map from viewBox coords to pixel coords.
 * @param {number} vbW - viewBox width
 * @param {number} vbH - viewBox height
 * @param {number} cW - container width in pixels
 * @param {number} cH - container height in pixels
 * @returns {{ scale: number, tx: number, ty: number }}
 */
function computeMeetTransform(vbW, vbH, cW, cH) {
	const scaleX = cW / vbW;
	const scaleY = cH / vbH;
	const scale = Math.min(scaleX, scaleY); // "meet" = use smaller scale
	const tx = (cW - vbW * scale) / 2; // center horizontally
	const ty = (cH - vbH * scale) / 2; // center vertically
	return { scale, tx, ty };
}

/**
 * Remove SVG clip-path and frame overlay from the map container.
 * @param {HTMLElement} [mapEl] - The #map element
 */
function removeShapeClip(mapEl) {
	const mapContainer = mapEl || document.getElementById('map');
	if (mapContainer) {
		mapContainer.style.clipPath = 'none';
	}

	// Remove clip SVG
	const clipSvg = document.getElementById('shape-clip-svg');
	if (clipSvg) clipSvg.remove();

	// Remove frame overlay SVG
	const frameSvg = document.getElementById('shape-frame-svg');
	if (frameSvg) frameSvg.remove();
}

/**
 * Update the clip-path and frame overlay to match current map container size.
 * Call this on resize or orientation change when a shape is active.
 */
function updateShapeOverlaySize() {
	const frameSvg = document.getElementById('shape-frame-svg');
	const clipSvg = document.getElementById('shape-clip-svg');
	if (!frameSvg && !clipSvg) return;

	const mapContainer = document.getElementById('map');
	if (!mapContainer) return;

	const containerWidth = mapContainer.offsetWidth;
	const containerHeight = mapContainer.offsetHeight;

	// Update frame overlay height
	if (frameSvg) {
		frameSvg.style.height = containerHeight + 'px';
	}

	// Update clip-path coordinates to match new container size
	if (clipSvg) {
		const clipPathEl = clipSvg.querySelector('#active-shape-clip');
		if (!clipPathEl) return;

		// Determine which shape is active
		const shapeEl = clipPathEl.firstChild;
		if (!shapeEl) return;

		// Find the active shape data
		let data;
		if (shapeEl.tagName === 'ellipse') {
			data = SVG_SHAPES.circle;
			const fit = computeMeetTransform(data.width, data.height, containerWidth, containerHeight);
			shapeEl.setAttribute('cx', fit.tx + data.ellipseCx * fit.scale);
			shapeEl.setAttribute('cy', fit.ty + data.ellipseCy * fit.scale);
			shapeEl.setAttribute('rx', data.ellipseRx * fit.scale);
			shapeEl.setAttribute('ry', data.ellipseRy * fit.scale);
		} else {
			data = SVG_SHAPES.heart;
			const fit = computeMeetTransform(data.width, data.height, containerWidth, containerHeight);
			shapeEl.setAttribute('transform', 'translate(' + fit.tx + ',' + fit.ty + ') scale(' + fit.scale + ')');
		}
	}
}

/**
 * Update the frame overlay fill color (call when background color changes).
 * @param {string} color - CSS color value
 */
function updateShapeFrameColor(color) {
	const framePath = document.getElementById('shape-frame-path');
	if (framePath) {
		framePath.setAttribute('fill', color);
	}
}

/**
 * Get the current background color from the preview title or default to white.
 * @returns {string} CSS color value
 */
function getCurrentBackgroundColor() {
	if (typeof customColors !== 'undefined' && customColors.background) {
		return customColors.background;
	}
	const previewTitle = document.querySelector('.map-preview-title');
	if (previewTitle) {
		const bg = window.getComputedStyle(previewTitle).backgroundColor;
		if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
			return bg;
		}
	}
	return '#FFFFFF';
}
